var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.684,
    height: 30,
    viewBox: "0 0 23.684 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "map-marker-Filled_1_",
    d: "M222.5,2783.342a3.158,3.158,0,1,1-3.158-3.158A3.167,3.167,0,0,1,222.5,2783.342Zm8.684,0c0,9.6-7.374,15.616-10.532,17.748a2.222,2.222,0,0,1-1.311.411,2.3,2.3,0,0,1-1.326-.411c-3.158-2.131-10.516-8.131-10.516-17.748a11.842,11.842,0,0,1,23.684,0Zm-5.526,0a6.316,6.316,0,1,0-6.316,6.316A6.314,6.314,0,0,0,225.658,2783.342Z",
    transform: "translate(-207.5 -2771.5)",
    fill: "#e23744"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.20de5718105c69ede43eb74f827507d4.svg";
export { ForwardRef as ReactComponent };